import { axiosInstance, API_PREFIX, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type { ApplicationBase } from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/application`;

export const getList = async (params?: RequestParams): Promise<ApiResponseList<ApplicationBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<ApplicationBase>>(`${BASE}/index`, { params });
  return data;
};
